import { PropsWithChildren } from "react";
import * as RadixAccordion from "@radix-ui/react-accordion";
import { clsx } from "clsx";
import { AccordionItem, AccordionTrigger } from "./components";
import "./Accordion.css";

export enum AccordionType {
  single = "single",
  multiple = "multiple",
}

export type AccordionProps = PropsWithChildren<
  RadixAccordion.AccordionSingleProps | RadixAccordion.AccordionMultipleProps
>;

export function Accordion({ children, ...rest }: AccordionProps) {
  return <RadixAccordion.Root {...rest}>{children}</RadixAccordion.Root>;
}

const AccordionContent = ({ className, ...props }: RadixAccordion.AccordionContentProps) => (
  <RadixAccordion.Content {...props} className={clsx("AccordionContent", className)} />
);

Accordion.Type = AccordionType;
Accordion.Item = AccordionItem;
Accordion.Trigger = AccordionTrigger;
Accordion.Content = AccordionContent;
Accordion.Header = RadixAccordion.Header;

export default Accordion;
